import { Button } from '@/components/ui/button';
import {
  fCurrency,
  fCurrencyExtended,
  fCurrencyUSDExtended,
} from '@/utils/formatNumber';
import SpendingLimit from './SpendingLimit';
import { Link } from 'react-router-dom';
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import {
  useGetUserBalance,
  useGetUserCurrentBalance,
} from '@/service/payment/hook';
import { fFullDateTime } from '@/utils/formatTime';
import { createTopupSession } from '@/service/payment';
import useAuth from '@/auth/useAuth';
import { Skeleton } from '@/components/ui/skeleton';
import { PATH_CONTACT, STRIPE_LOGIN_URL } from '@/constants';
import { StripeIcon, StripeSMIcon } from '@/components/ui/icons';
import ViewCredit from '../view-credit';

const Overview = () => {
  const getBalance = useGetUserCurrentBalance();
  const balance = getBalance.data?.balance || 0;
  const maxBalance = getBalance.data?.max_balance || 0;
  const spendingLimit = maxBalance - balance;
  const lastUpdateBalance = fFullDateTime(getBalance?.dataUpdatedAt || '');

  return (
    <>
      <div className="flex flex-col divide-y *:py-6 first:*:pt-0 last:*:pb-0">
        <div className="space-y-6">
          <div className="grid gap-2 sm:grid-cols-2">
            <div className="flex flex-col gap-1">
              <p className="text-base font-medium">Spending Limit</p>
              <p className="max-w-lg text-pretty text-muted-foreground">
                Your spending limit resets on the 1st of each month, which is
                the beginning of your billing cycle. You will only be charged
                for what you use.
              </p>
              <p className="text-muted-foreground">
                Last updated: {lastUpdateBalance}
              </p>
            </div>
            {!getBalance.isLoading ? (
              <div className="w-fit text-2xl font-medium">
                {fCurrencyUSDExtended(spendingLimit)}
                <p className="text-end text-sm font-normal text-muted-foreground">
                  {' '}
                  {fCurrencyUSDExtended(maxBalance)}/month usage limit.
                </p>
              </div>
            ) : (
              <Skeleton className="h-8 w-20" />
            )}
          </div>

          <ViewCredit />
        </div>

        <div className="flex flex-col gap-8">
          <p className="text-lg font-medium">Payment Setting</p>
          {/* <div className="grid sm:grid-cols-2 gap-2">
            <div className="flex flex-col gap-1">
              <p className="text-base font-medium">Payment Method</p>
              <p className="text-muted-foreground">
                Add or change payment method.
              </p>
              <Button variant="outline" className="self-start">
                change payment method
              </Button>
            </div>
            <div>1234</div>
          </div> */}
          {/* SpendingLimit */}
          {/* <SpendingLimit /> */}
          {/* log */}
          <div className="grid gap-2 sm:grid-cols-2">
            <div className="flex flex-col gap-1">
              <p className="text-base font-medium">Customer Management</p>
              <div className="flex flex-col items-start">
                <span className="text-muted-foreground">
                  You can pay via credit/debit card by setting up your payment
                  method in Stripe.
                  <br /> For bank transfers, invoices, receipts, or others
                  please contact support@float16.cloud.
                </span>
              </div>
            </div>
            <Link
              to={STRIPE_LOGIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2"
            >
              <Button
                variant={'outline'}
                startIcon={<StripeSMIcon className="h-6 w-6" />}
                endIcon={<ArrowTopRightIcon />}
                className="w-fit"
              >
                Go to Stripe
              </Button>
            </Link>
          </div>
          {/* SpendingLimit contact support */}
          <div className="grid gap-2 sm:grid-cols-2">
            <div className="flex flex-col gap-1">
              <p className="text-base font-medium">Adjust Spending limit</p>
              <p className="text-muted-foreground">
                If you need to adjust your spending limit, please contact
                support.
              </p>
            </div>
            <Link
              to={PATH_CONTACT.support}
              target="_blank"
              rel="noopener noreferrer"
              className="w-fit"
            >
              <Button variant={'link'} endIcon={<ArrowTopRightIcon />}>
                Contact Support
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
